var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcMore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 4,
    viewBox: "0 0 16 4",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.28572 2.09828C3.28572 2.96616 2.58217 3.66971 1.71429 3.66971C0.846413 3.66971 0.14286 2.96616 0.14286 2.09828C0.14286 1.23041 0.846413 0.526855 1.71429 0.526855C2.58217 0.526855 3.28572 1.23041 3.28572 2.09828Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.57143 2.09828C9.57143 2.96616 8.86788 3.66971 8 3.66971C7.13213 3.66971 6.42858 2.96616 6.42858 2.09828C6.42858 1.23041 7.13213 0.526855 8 0.526855C8.86788 0.526855 9.57143 1.23041 9.57143 2.09828Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8571 2.09828C15.8571 2.96616 15.1536 3.66971 14.2857 3.66971C13.4178 3.66971 12.7143 2.96616 12.7143 2.09828C12.7143 1.23041 13.4178 0.526855 14.2857 0.526855C15.1536 0.526855 15.8571 1.23041 15.8571 2.09828Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMore);
export default __webpack_public_path__ + "static/media/ic_more.5477375266d80ac4d8deb7953d29311e.svg";
export { ForwardRef as ReactComponent };